import styled from 'styled-components';

import {Button} from 'components/ui-kit/Button';
import {breakpoint} from 'theme';

export const ControlsWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    @media (min-width: ${breakpoint.phone}) {
        justify-content: flex-start;
        width: auto;
    }
`;

export const CreateButton = styled(Button)`
    @media (min-width: ${breakpoint.phone}) {
        max-width: 180px;
    }
`;
